import React, { useState, useEffect, useContext, useRef } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Col, Form, Row, Spinner, Modal } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Box } from "@mui/material";
import cardnumber from "../assets/images/Billing/Cardnumber.svg";
import cardnumberQ5 from "../assets/images/Billing/Cardnumber-Q5.svg";
import CVVpayment from "../assets/images/Billing/CVV-payment.svg";
import CVVpaymentQ5 from "../assets/images/Billing/CVV-payment-Q5.svg";
import ABAroutingimg from "../assets/images/Billing/ABA-Routing.svg";
import cardholder from "../assets/images/icons/Card.svg";
import "../assets/css/Style.css";
import "react-datepicker/dist/react-datepicker.css";
import { JSEncrypt } from "jsencrypt";
import { getApiService } from "../services/ApiService";
import { GetPayLoad } from "../services/PayLoadStorage";
import { Country, State, City } from 'country-state-city';
import { postData } from "../services/EncryptService";
import { LanguageContext } from "../contexts/LanguageContext";

const Forms = ({ handleCloseModal, sendDataToParent, contentFromExternal = null }) => {

    //This  is Localstorage value
    const Payload = GetPayLoad('PayLoad');

    const renderTooltip = (props) => (
        <Tooltip {...props} className="tooltip-img-wide">
            <img src={Payload?.owning_carrier === 'Q5' ? cardnumberQ5 : cardnumber} alt="Card Number Help" />
        </Tooltip>
    );
    const renderTooltip1 = (props) => (
        <Tooltip {...props} className="tooltip-img-wide">
            <img src={Payload?.owning_carrier === 'Q5' ? CVVpaymentQ5 : CVVpayment} alt="CVV Help" />
        </Tooltip>
    );
    const ABAroutingTooltip = (props) => (
        <Tooltip {...props} className="tooltip-img-wide">
            <img src={ABAroutingimg} alt="ABA Routing Help" />
        </Tooltip>
    );
    const [accountKey, setAccountKey] = useState('cc');
    const [expiryDate, setExpiryDate] = useState(null);
    const [autocompleteValue, setAutocompleteValue] = useState('cc-csc');
    const [formSubmitType, setFormSubmitType] = useState('CCD');

    const [open, setOpen] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [key, setKey] = useState('case-info');
    const [dbtExpVal, setdbtExpVal] = useState("");
    const [dbtExpErr, setdbtExpErr] = useState("");
    const [formLable, setFormLable] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const expiryMonth = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const currentYear = new Date().getFullYear();
    const expiryYear = [];
    for (let i = 0; i <= 14; i++) {
        expiryYear.push(currentYear + i);
    }
    const { pageContent } = useContext(LanguageContext);
    const [overViewContent, setOverViewContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);
    const [paymentConfig, setPaymentConfig] = useState([]);
    const [debitCardAllowed, setDebitCardAllowed] = useState(false);

    useEffect(() => {
        loadFromLocalStorage();
        if (pageContent?.overview) {
            setOverViewContent(pageContent.overview);
        }

        if (pageContent?.billing) {
            setOverViewContent(pageContent.billing);
        }else if (contentFromExternal?.billing) { // This is to handle the case where content is fetched from an external source
			setOverViewContent(contentFromExternal.billing);
		}

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }else if (contentFromExternal?.generic) { // This is to handle the case where content is fetched from an external source
			setGenericContent(contentFromExternal.generic);
		}

    }, [pageContent]);

    const [apiCallsCompleted, setApiCallsCompleted] = useState(false);
    const ref = useRef(null); // Ref for the <main> tag
    const [caseInfo, setCaseInfo] = useState([]);

    const [billingaddress1, setAddress1] = useState();
    const [billingaddress2, setAddress2] = useState();
    const [caseAddress, setCaseAddress] = useState();
    const [caseZipAndState, setCaseZipAndState] = useState();
    const [caseZip, setCaseZip] = useState();
    const [caseState, setCaseState] = useState();
    const [caseCity, setCaseCity] = useState();
    const [zip, setZipCode] = useState();
    const [phonenumber, setPhoneNumber] = useState();
    const [state, setState] = useState();
    const [city, setCity] = useState(); // Initialize with case state
    const [eftbillingaddress1, setEFTAddress1] = useState();
    const [eftbillingaddress2, setEFTAddress2] = useState();
    const [eftzip, setEFTZipCode] = useState();
    const [eftstate, setEFTState] = useState();
    const [eftcity, setEFTCity] = useState(); // Initialize with case state
    const [cardname, setCardName] = useState();
    const [accountname, setAccountName] = useState();         
    const [eftphonenumber, setEFTPhoneNumber] = useState();

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier
    };

    useEffect(() => {
        setLoading(true);
        const targetCaseUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
        getApiService(baseUrl, targetCaseUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                   const result = response.data.data;
                    setCaseInfo(result);
                    setLoading(false);
                }
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            
            });
    }, []);

    useEffect(() => {

        // Ensure caseInfo is available before accessing its properties
        if(!caseInfo) return;

        setPhoneNumber(caseInfo?.phoneNumber?.replace(/[^0-9]/g, ''));
        setCardName(caseInfo?.displayName);
        setEFTPhoneNumber(caseInfo?.phoneNumber?.replace(/[^0-9]/g, ''));
        setAccountName(caseInfo?.displayName);

        if (caseInfo?.mailAddress) {
            // Split the mailAddress by commas and trim each part
            let sCaseAddress = caseInfo.mailAddress.split(',').map(part => part.trim());
            setAddress1(sCaseAddress[0]);
            setCaseAddress(sCaseAddress[0]);
            setEFTAddress1(sCaseAddress[0]);
            if (sCaseAddress.length > 3) {
                setAddress2(sCaseAddress[sCaseAddress.length - 3]); // Assuming the second last element is the address line 2
                setEFTAddress2(sCaseAddress[sCaseAddress.length - 3]); // Assuming the second last element is the address line 2
            } else {
                setAddress2(''); // If there is no address line 2, set it to an empty string
                setEFTAddress2(''); // If there is no address line 2, set it to an empty string
            }
            let sCaseZipAddress = sCaseAddress[sCaseAddress.length - 1].trim().split(' ');
            setCaseZipAndState(sCaseAddress[sCaseAddress.length - 1].trim().split(' '));
            setZipCode(sCaseZipAddress[1].substring(0, 5)); // Extracting first 5 characters for zip code
            setEFTZipCode(sCaseZipAddress[1].substring(0, 5)); // Extracting first 5 characters for zip code
            setState(sCaseZipAddress[0].trim()); // Extracting state code
            setEFTState(sCaseZipAddress[0].trim()); // Extracting state code
            setCity(titleCase(sCaseAddress[sCaseAddress.length - 2]));
            setEFTCity(titleCase(sCaseAddress[sCaseAddress.length - 2]));
            // Set after all state updates are complete to ensure render is finished
            setTimeout(() => {
                setApiCallsCompleted(true);
            }, 0);
        } else {
            setAddress2(''); // If mailAddress is not available, set it to an empty string
            setEFTAddress2(''); // If mailAddress is not available, set it to an empty string
        }
    }, [caseInfo]);

    // Load object from localStorage
    const loadFromLocalStorage = () => {
        
        if(localStorage.getItem('paymentConfig') === null || localStorage.getItem('paymentConfig') === 'null' || localStorage.getItem('paymentConfig') === '' || localStorage.getItem('paymentConfig') === 'undefined'){
                setPaymentConfig(null);
        } else{

            if(Payload?.owning_carrier !== 'X6' && typeof localStorage.getItem('paymentConfig') !== 'undefined') {
                const config = localStorage.getItem('paymentConfig');
                if (config) {
                    setPaymentConfig(JSON.parse(config));
                }
            }
        }
    };

    const countryCode = 'US';
    const country = Country.getCountryByCode(countryCode);
    //const [countries, setCountries] = useState(Country.getAllCountries());
    const [states, setStates] = useState(State.getStatesOfCountry(country.isoCode));


    const [selectedState, setSelectedState] = useState();
    function titleCase(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
    }

    useEffect(() => {
        const debitHeaders = {
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region": Payload?.region,
            "X-Hps-Carrier": Payload?.owning_carrier
        };
        const targetDebitRuleUrl = process.env.REACT_APP_API_GET_DEBITCARD_RULE_VALUE_ENDPOINT;
        getApiService(baseUrl, targetDebitRuleUrl, { cim: Payload?.cim }, debitHeaders)
            .then((response) => {
                if (response?.data?.statusCode !== 200) {
                    setDebitCardAllowed(false);
                } else {
                    setDebitCardAllowed(response.data.data);
                    setIsChecked(response.data.data);
                }
            })
            .catch(error => {
                setDebitCardAllowed(false);
            });
    },[]);
    /*const caseAddress = caseInfo?.mailAddress.split(',');
    console.log(caseAddress, 'caseAddress');
    if(caseAddress.length >= 3) {
        setAddress2(caseAddress[caseAddress.length - 3].trim()); // Assuming the second last element is the address line 2
    }else{
        setAddress2(''); // If there is no address line 2, set it to an empty string
    }*/
    //const caseZipAndState = caseAddress[2].trim().split(' ');
    
    
    const [selectedMonth, setSelectedMonth] = useState(expiryMonth[0]);
    const [selectedYear, setSelectedYear] = useState(expiryYear);

    const handleMonthChange = (e) => {
        const selectedMonth = e.target.value;
        setCCFormValues(prev => ({
            ...prev,

            expiryMonth: selectedMonth,
        }));
        if(ccFormErrors?.expiryMonth) {
            setCCFormErrors(prev => ({
                ...prev,
                expiryMonth: "",
            }));
        }
    };

    const handleYearChange = (e) => {
        let selectedYear = e.target.value;
        setCCFormValues(prev => ({
            ...prev,
            expiryYear: selectedYear,
        }));
        if(ccFormErrors?.expiryYear) {
            setCCFormErrors(prev => ({
                ...prev,
                expiryYear: "",
            }));
        }
    };
    
    const [ccFormErrors, setCCFormErrors] = useState({});
    const [paymentaccount, setPaymentaccount] = useState('PERSONAL');
    const [eftFormErrors, setEFTFormErrors] = useState({});
    const [ccFormValues, setCCFormValues] = useState({
        ccnumber: "",
        reenterccnumber: "",
        cardtype: "",
        isDebitCard: false,
        cardname: "",
        expirydate: "",
        expiryMonth: "",
        expiryYear: "",
        cvv: "",
        paymentaccount: paymentaccount,
        billingaddress1: "",
        billingaddress2: "",
        state: "",
        city: "",
        zip: "",
        phonenumber: "",
    });

       
    const [accounttype, setAccounttype] = useState('CHECKING'); 
    const [accountuse, setAccountuse] = useState('PERSONAL'); 
    const [eftFormValues, setEFTFormValues] = useState({
        routingnumber: "",
        reenterroutingnumber: "",
        accountnumber: "",
        reenteraccountnumber: "",
        accounttype: accounttype,
        accountname: "",
        accountuse: accountuse,
        eftbillingaddress1: "",
        eftbillingaddress2: "",
        eftstate: "",
        eftcity: "",
        eftzip: "",
        eftphonenumber: "",
    });
    const [cities, setCities] = useState(City.getCitiesOfState(country.isoCode, caseState)); // Initialize with case state

    const handleStateChange = (state) => {
        setState(state.isoCode);
        setSelectedState(state.isoCode);
        setCCFormValues(prev => ({
            ...prev,

            state: state.isoCode,
        }));
        setCities(City.getCitiesOfState(country.isoCode, state.isoCode));
    };
    const handleCityChange = (city) => {
        setCity(city.target.value);
        //setCities(city.target.value);
        setCCFormValues(prev => ({
            ...prev,

            city: city.target.value,
        }));
    };
    const [eftCities, setEftCities] = useState(City.getCitiesOfState(country.isoCode, caseState));
    const handleEFTStateChange = (state) => {
        setSelectedState(state.isoCode);
        setEFTState(state.isoCode);
        setEFTFormValues(prev => ({
            ...prev,

            eftstate: state.isoCode,
        }));
        setEftCities(City.getCitiesOfState(country.isoCode, state.isoCode));
    };

    const handleEFTCityChange = (city) => {
        setEFTCity(city.target.value);
        setEFTFormValues(prev => ({
            ...prev,

            eftcity: city.target.value,
        }));
    };


    const handleNameChange = (event) => {
        setCardName(event.target.value);
        setCCFormValues(prev => ({
            ...prev,
            cardname: event.target.value,
        }));
        const filteredValue = event.target.value.replace(/[^a-zA-Z\s]/g, ''); 
        setCardName(filteredValue);
    };
    const handleAddressChange = (event) => {
        setAddress1(event.target.value);
        setCCFormValues(prev => ({
            ...prev,
            billingaddress1: event.target.value,
        }));
    };
    const handleZipCodeChange = (event) => {
        setZipCode(event.target.value);
        setCCFormValues(prev => ({
            ...prev,
            zip: event.target.value,
        }));
    };
    const handlePhoneNumberChange = (event) => {
        setPhoneNumber(event.target.value);
        setCCFormValues(prev => ({
            ...prev,
            phonenumber: event.target.value,
        }));
    };
    const EFThandleNameChange = (event) => {
        setAccountName(event.target.value);
        setEFTFormValues(prev => ({
            ...prev,
            accountname: event.target.value,
        }));
        const filteredValue = event.target.value.replace(/[^a-zA-Z\s]/g, ''); 
        setAccountName(filteredValue);
    };
    const EFThandleAddressChange = (event) => {
        setEFTAddress1(event.target.value);
        setEFTFormValues(prev => ({
            ...prev,
            eftbillingaddress1: event.target.value,
        }));
    };
    const EFThandleAddress2Change = (event) => {
        setEFTAddress2(event.target.value);
        setEFTFormValues(prev => ({
            ...prev,
            eftbillingaddress2: event.target.value,
        }));
    };
    const EFThandleZipCodeChange = (event) => {
        setEFTZipCode(event.target.value);
        setEFTFormValues(prev => ({
            ...prev,
            eftzip: event.target.value,
        }));
    };
    const EFThandlePhoneNumberChange = (event) => {
        setEFTPhoneNumber(event.target.value);
        setEFTFormValues(prev => ({
            ...prev,
            eftphonenumber: event.target.value,
        }));
    };
    
    const handleChange = (e) => {
        
        const { name, value, type, checked } = e.target;
        const fieldValue = type === "checkbox" ? checked : value;
        setCCFormErrors({ ...ccFormErrors, [name]: "" }); // Clear error for the field being edited
        if(name === "paymentaccount") {
            setPaymentaccount(fieldValue);
            setCCFormValues({ ...ccFormValues, [name]: fieldValue });
        }
        setCCFormValues({ ...ccFormValues, [name]: fieldValue });
    }
    const efthandleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const fieldValue = type === "checkbox" ? checked : value;
        setEFTFormErrors({ ...eftFormErrors, [name]: "" }); // Clear error for the field being edited
        if(name === "accounttype") {
            setAccounttype(fieldValue);
            setEFTFormValues({ ...eftFormValues, [name]: fieldValue });
        }
        if(name === "accountuse") {
            setAccountuse(fieldValue);
            setEFTFormValues({ ...eftFormValues, [name]: fieldValue });
        }
        setEFTFormValues({ ...eftFormValues, [name]: fieldValue });
    }

    function getJsonString(postdata) {
        let jsonString = "{";
        for (let key in postdata) {
            if (postdata.hasOwnProperty(key)) {
                jsonString = jsonString + `"${key}":"${postdata[key]}",`;
            }
        }
        jsonString = jsonString.slice(0, -1) + "}"; // Remove the last comma and close the brace
        return jsonString;
    }
    //const { encryptText } = useContext(JSEncryptContext);
    function encryptText(stringData) {
        var encrypt = new JSEncrypt();
        const pubkey = process.env.REACT_APP_PUB_KEY;
        encrypt.setPublicKey(pubkey);
        var encrypted = encrypt.encrypt(stringData);
        return encrypted;
    }
    function getEncryptedPostdataString(postdata) {
        // Creating specific postdata sections using object literals
        const postdataName = {
            first_name: postdata.first_name,
            last_name: postdata.last_name,
        };

        const postdataAddress = {
            street1: postdata.street1,
            street2: postdata.street2,
            city: postdata.city,
            state: postdata.state,
            zip: postdata.zip,
            country: postdata.country,
        };

        const postdataContact = {
            email: postdata.email,
            phone: postdata.phone,
            carrier_code: postdata.carrier_code,
            debit_card_flag: postdata.debit_card_flag,
        };

        const postdataPayment = (postdata.method == 'EFT') ? {
            check_type: postdata.check_type,
            check_routing: postdata.check_routing,
            check_level: postdata.check_level,
            method: postdata.method,
            cc_type: postdata.cc_type,
            /* cc_number: postdata.cc_number,
            cc_exp_month: postdata.cc_exp_month,
            cc_exp_year: postdata.cc_exp_year,
            card_cvNumber: postdata.card_cvNumber,*/
            check_number: postdata.check_number,
            currency: postdata.currency,
        } : {
            method: postdata.method,
            cc_type: postdata.cc_type,
            cc_number: postdata.cc_number,
            cc_exp_month: postdata.cc_exp_month,
            cc_exp_year: postdata.cc_exp_year,
            card_cvvNumber: postdata.card_cvNumber,
            currency: postdata.currency,
        };


        // Convert object to JSON string (to be encrypted, for example)
        //const postdataString = JSON.stringify(encryptedPostdata);
        const postdataNameStr = getJsonString(postdataName);
        const postdataNameStrEn = encryptText(postdataNameStr);
        const postdataNameParam = `en_nm=${encodeURIComponent(postdataNameStrEn)}`;

        const postdataAddressStr = getJsonString(postdataAddress);
        const postdataAddressStrEn = encryptText(postdataAddressStr);
        const postdataAddressParam = `en_ad=${encodeURIComponent(
            postdataAddressStrEn
        )}`;

        const postdataContactStr = getJsonString(postdataContact);
        const postdataContactStrEn = encryptText(postdataContactStr);
        const postdataContactParam = `en_cn=${encodeURIComponent(
            postdataContactStrEn
        )}`;

        const postdataPaymentStr = getJsonString(postdataPayment);
        const postdataPaymentStrEn = encryptText(postdataPaymentStr);
        const postdataPaymentParam = `en_pi=${encodeURIComponent(
            postdataPaymentStrEn
        )}`;

        // Combine all the parameters using a template literal or join
        const postdataString = [
            postdataNameParam,
            postdataAddressParam,
            postdataContactParam,
            postdataPaymentParam,
        ].join("&"); // Using .join to concatenate the strings with '&'    return postdataString; // You would return this to be encrypted or used further
        return postdataString;
    }

    //Validate credit card
    const validateCreditCard = (cardNumber) => {
        // Regular expression for validating common credit card formats (Visa, MasterCard, etc.)
        // const cardPattern =
        //     /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9]{2})[0-9]{12}|3[47][0-9]{13}|(6011|622|64[4-9]|65)[0-9]{13,16}|2221[0-9]{12}|2222[0-9]{12}|2223[0-9]{12}|2224[0-9]{12}|2225[0-9]{12}|2226[0-9]{12}|2227[0-9]{12}|2228[0-9]{12}|2229[0-9]{12}|2230[0-9]{12}|2231[0-9]{12}|2232[0-9]{12}|2233[0-9]{12}|2234[0-9]{12}|2235[0-9]{12}|2236[0-9]{12}|2237[0-9]{12}|2238[0-9]{12}|2239[0-9]{12})$/;
        // return cardPattern.test(cardNumber) && luhnCheck(cardNumber);
        const cardPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9]{2})[0-9]{12}|3[47][0-9]{13}|(6011|622|64[4-9]|65)[0-9]{13,16})$/;
        return luhnCheck(cardNumber);
    };

    const luhnCheck = (cardNumber) => {
        let sum = 0;
        let shouldDouble = false;
        for (let i = cardNumber.length - 1; i >= 0; i--) {
            let digit = parseInt(cardNumber.charAt(i), 10);
            if (shouldDouble) {
                digit *= 2;
                if (digit > 9) digit -= 9;
            }
            sum += digit;
            shouldDouble = !shouldDouble;
        }
        return sum % 10 === 0;
    };

    // Validate the phone number using a regex
    /*const isValidPhone = (value) => {
      let isValidPhoneNumber = true;
      const regex = /^\(\d{3}\) \d{3}-\d{4}$/;
      if (!regex.test(value) && value.length === 14) {
        // 14 is length of (XXX) XXX-XXXX format
        isValidPhoneNumber = false;
      }
      return isValidPhoneNumber;
    };*/

    const isValidPhoneNumber = (value) => {
        const regex = /^\d{10,14}$/; // Matches 10 to 14 digits
        return regex.test(value);
    };

    const isValidZipCode = (value) => {
        const regex = /^\d{5}$/; // Matches exactly 5 digits
        return regex.test(value);
    };

    const validateAddress = (value) => {
        const pattern = /^[0-9a-zA-Z ,&.'\-\/#;\)=:]{1,255}$/;
        return pattern.test(value); // allows letters, numbers, and spaces
    };

    const isValidRoutingNumber = (numberString) => {
        // Check for consecutive repeating digits (e.g., "1111")
        if (/(.)\1{4,}/.test(numberString)) { // Matches any digit repeated 5 or more times
          return 'consucutive';
        }
    
        // Check for consecutive sequential digits (e.g., "1234")
        for (let i = 0; i < numberString.length - 3; i++) {
          const sub = numberString.substring(i, i + 4);
          if (
            (parseInt(sub[0]) + 1 === parseInt(sub[1]) &&
             parseInt(sub[1]) + 1 === parseInt(sub[2]) &&
             parseInt(sub[2]) + 1 === parseInt(sub[3])) || // Ascending sequence
            (parseInt(sub[0]) - 1 === parseInt(sub[1]) &&
             parseInt(sub[1]) - 1 === parseInt(sub[2]) &&
             parseInt(sub[2]) - 1 === parseInt(sub[3]))    // Descending sequence
          ) {
            return 'sequential';
          }
        }
    
        return ''; // No error
      };
    const validation = () => {
        let isValid = true
        const errors = {}
        if (ccFormValues?.ccnumber === "") {
            errors.ccnumber = overViewContent.billing_add_account_cc_no_required_err
            isValid = false
        } else {
            if (ccFormValues?.ccnumber && !validateCreditCard(ccFormValues.ccnumber)) {
                errors.ccnumber = overViewContent.billing_add_account_cc_correct_format_err
                isValid = false
            }

        }
        if (ccFormValues?.reenterccnumber === "") {
            errors.reenterccnumber = overViewContent.billing_add_account_re_enter_cc_err
            isValid = false
        }
        if (
            ccFormValues?.ccnumber &&
            ccFormValues?.reenterccnumber &&
            ccFormValues.ccnumber !== ccFormValues.reenterccnumber
        ) {
            errors.reenterccnumber = overViewContent.billing_add_account_re_enter_cc_same_err
            isValid = false
        }
        if (ccFormValues?.cardtype === "") {
            errors.type = overViewContent.billing_add_account_card_type_err
            isValid = false
        }
        if (cardname === "") {
            errors.cardname = overViewContent.billing_add_account_card_holder_name_err
            isValid = false
        }
        if (ccFormValues?.expiryMonth === "") {
            errors.expiryMonth = overViewContent.billing_add_account_expiry_month_err
            isValid = false
        }
        if (ccFormValues?.expiryYear === "") {
            errors.expiryYear = overViewContent.billing_add_account_expiry_year_err
            isValid = false
        }
        if (ccFormValues?.cvv === "") {
            errors.cvv = overViewContent.billing_add_account_cvv_err
            isValid = false
        } else if (ccFormValues?.cvv?.length != 3) {
            errors.cvv = overViewContent.billing_add_account_valid_cvv_err
            isValid = false
        }
        if (paymentaccount === "") {
            errors.paymentaccount = overViewContent.billing_add_account_payment_account_err
            isValid = false
        }
        if (billingaddress1 === "") {
            errors.billingaddress1 = overViewContent.billing_add_account_billing_address1_err
            isValid = false
        }
        if (state === "" || state === "Select State") {
            errors.state = overViewContent.billing_add_account_state_err
            isValid = false
        }
        if (city === "" || city === "Select City") {
            errors.city = overViewContent.billing_add_account_city_err
            isValid = false
        }
        if (zip === "") {
            errors.zip = overViewContent.billing_add_account_zip_err
            isValid = false
        } else {
            if (zip && !isValidZipCode(zip)) {
                errors.zip = overViewContent.billing_add_account_zip_format_err
                isValid = false
            }

        }
        if (phonenumber === "") {
            errors.phonenumber = overViewContent.billing_add_account_phone_no_err
            isValid = false
        } else {
            if (phonenumber && !isValidPhoneNumber(phonenumber)) {
                errors.phonenumber = overViewContent.billing_add_account_phone_no_format_err
                isValid = false
            }

        }
        setCCFormErrors(errors)
        return isValid
    }
    const accountNumberPattern = /^\d{4,17}$/;

    const eftvalidation = () => {
        let isValid = true
        const errors = {}
        if (eftFormValues?.routingnumber === "") {
            errors.routingnumber = overViewContent.billing_add_account_eft_routing_no_err
            isValid = false
        }


        if (eftFormValues?.reenterroutingnumber === "") {
            errors.reenterroutingnumber = overViewContent.billing_add_account_eft_re_enter_routing_no_err
            isValid = false
        }
        if (!/^\d{9}$/.test(eftFormValues?.routingnumber)) {
            errors.routingnumber = overViewContent.billing_add_account_eft_routing_no_valid_err
            isValid = false;
        }

        if (isValidRoutingNumber(eftFormValues?.routingnumber)) {
            const routingError = isValidRoutingNumber(eftFormValues?.routingnumber);
            if (routingError === 'consucutive') {
                errors.routingnumber = genericContent.billing_add_account_eft_routing_no_consecutive_err
                isValid = false;
            }
            if (routingError === 'sequential') {
                errors.routingnumber = genericContent.billing_add_account_eft_routing_no_sequential_err
                isValid = false;
            }
        }

        if (!/^\d{9}$/.test(eftFormValues?.reenterroutingnumber)) {
            errors.reenterroutingnumber = overViewContent.billing_add_account_eft_re_enter_routing_no_valid_err
            isValid = false;
        }
        if (
            eftFormValues?.routingnumber !== "" &&
            eftFormValues?.reenterroutingnumber !== "" &&
            eftFormValues.routingnumber !== eftFormValues.reenterroutingnumber
        ) {
            errors.reenterroutingnumber = overViewContent.billing_add_account_eft_routing_numbers_match_err
            isValid = false;
        }

        if (eftFormValues?.accountnumber === "") {
            errors.accountnumber = overViewContent.billing_add_account_eft_account_no_err
            isValid = false;
        }
        else if (eftFormValues.accountnumber.length < 4 || eftFormValues.accountnumber.length > 17 || isNaN(eftFormValues.accountnumber)) {
            errors.accountnumber = overViewContent.billing_add_account_eft_account_no_valid_err
            isValid = false;
        }
        if (eftFormValues?.reenteraccountnumber === "") {
            errors.reenteraccountnumber = overViewContent.billing_add_account_eft_re_enter_account_no_err
            isValid = false;
        } else if (eftFormValues.reenteraccountnumber.length < 4 || eftFormValues.reenteraccountnumber.length > 17 || isNaN(eftFormValues.reenteraccountnumber)) {
            errors.reenteraccountnumber = overViewContent.billing_add_account_eft_re_enter_account_no_valid_err
            isValid = false;
        }
        if (eftFormValues?.accountnumber && eftFormValues?.reenteraccountnumber &&
            eftFormValues.accountnumber !== eftFormValues.reenteraccountnumber) {
            errors.reenteraccountnumber = overViewContent.billing_add_account_eft_account_no_match_err
            isValid = false;
        }

        if (eftFormValues?.accounttype === "" || eftFormValues?.accounttype === "") {
            errors.accounttype = overViewContent.billing_add_account_eft_account_type_err
            isValid = false
        }

        if (eftFormValues?.accountuse === "" || eftFormValues?.accountuse === "") {
            errors.accountuse = overViewContent.billing_add_account_eft_account_use_err
            isValid = false
        }

        if (accountname === "") {
            errors.accountname = overViewContent.billing_add_account_eft_account_name_err
            isValid = false
        }

        if (eftbillingaddress1 === "") {
            errors.billingaddress1 = overViewContent.billing_add_account_billing_address1_err
            isValid = false
        }
        if (eftstate === "" || eftstate === "Select State") {
            errors.state = overViewContent.billing_add_account_state_err
            isValid = false
        }
        if (eftcity === "" || eftcity === "Select City") {
            errors.eftcity = overViewContent.billing_add_account_city_err
            isValid = false
        }
        if (eftzip === "") {
            errors.zip = overViewContent.billing_add_account_zip_err
            isValid = false
        } else {
            if (eftzip && !isValidZipCode(eftzip)) {
                errors.zip = overViewContent.billing_add_account_zip_format_err
                isValid = false
            }

        }
        if (eftphonenumber === "") {
            errors.phonenumber = overViewContent.billing_add_account_phone_no_err
            isValid = false
        } else {
            if (eftphonenumber && !isValidPhoneNumber(eftphonenumber)) {
                errors.phonenumber = overViewContent.billing_add_account_phone_no_format_err
                isValid = false
            }

        }

        setEFTFormErrors(errors)
        return isValid
    }


    let body_post_encrypt = "";
    let body_pre_encrypt = "";
    const APIHeaders = {
        "Content-Type": "application/x-www-form-urlencoded",
    };
    const handleSubmit = (e) => {
        e.preventDefault()
        // console.log(ccFormValues, 'ccFormValues')
        if (!validation()) {
            // console.log(ccFormValues, 'ccFormValues')
            setOpen(true)
        } else {
            // console.log(ccFormValues, 'ccFormValues1')
            // setOpen(true)
            let updatedMonth = parseInt(ccFormValues?.expiryMonth) + 1;
            let updateMonthTwodigit = updatedMonth.toString();
            updateMonthTwodigit = updateMonthTwodigit.padStart(2, '0');
            let updatedYear = ccFormValues?.expiryYear.slice(-2);
            body_pre_encrypt = {
                w1: "PciTokenCTL/PciWebProcessCTL",
                no_html: "true",
                process_type: "TOKENIZE_WEB_DATA",
                method: "CC",
                first_name: cardname,
                last_name: cardname,
                street1: billingaddress1,
                street2: ccFormValues?.billingaddress2,
                city: city,
                state: state,
                zip: zip,
                country: "US",
                email: ccFormValues?.email ? ccFormValues.email : "default@default.com",
                phone: phonenumber ? phonenumber : "9999999999",
                carrier_code: Payload?.owning_carrier,
                response_type: "json",
                cc_type: ccFormValues?.cardtype,
                cc_number: ccFormValues?.ccnumber,
                card_cvvNumber: ccFormValues?.cvv,
                cc_exp_month: updateMonthTwodigit,
                cc_exp_year: updatedYear,
                currency: "usd",
                debit_card_flag: "false",
                authsource:ccFormValues?.authsource ? ccFormValues.authsource : "WEB",
                //gateway_id: gatewayId,
            };

            body_post_encrypt = getEncryptedPostdataString(body_pre_encrypt);
            console.log(body_pre_encrypt);
            createAccount(body_post_encrypt, APIHeaders, body_pre_encrypt);
        }
    }

    const efthandleSubmit = (e) => {
        e.preventDefault()
        // console.log(ccFormValues, 'ccFormValues')
        if (!eftvalidation()) {
            console.log(eftFormValues, 'eftFormValues')
            setOpen(true)
        } else {
            console.log(eftFormValues, 'eftFormValues1')
            // setOpen(true)
            body_pre_encrypt = {
                w1: "PciTokenCTL/PciWebProcessCTL",
                no_html: "true",
                process_type: "TOKENIZE_WEB_DATA",
                method: "EFT",
                check_routing: eftFormValues?.routingnumber,
                check_number: eftFormValues?.accountnumber,
                check_level: eftFormValues?.accountuse,
                check_type: eftFormValues?.accounttype,
                first_name: accountname,

                last_name: accountname,
                // bankAccountHolderName: form?.bankAccountHolderName,
                street1: eftbillingaddress1,
                street2: eftbillingaddress2 ? eftbillingaddress2 : "",
                carrier_code: Payload?.owning_carrier,
                response_type: "json",
                email: eftFormValues?.email ? eftFormValues?.email : "default@default.com",
                city: eftcity,
                state: eftstate,
                zip: eftzip,
                phone: eftphonenumber ? eftphonenumber : "9999999999",
                currency: "usd",
                authsource: eftFormValues?.authsource ? eftFormValues.authsource : "WEB",
                //gateway_id: gatewayId,
            };
            body_post_encrypt = getEncryptedPostdataString(body_pre_encrypt);
            console.log(body_pre_encrypt);
            setFormSubmitType('EFT');
            createAccount(body_post_encrypt, APIHeaders, body_pre_encrypt);
        }
    }
    const createAccount = (body, APIHeaders, body_pre_encrypt) => {
        setLoading(true);
        let response = "";
        let fullUrl = '';
        let envUrl = 'REACT_APP_PCI_API_HTTP_URL_ENDPOINT_' + process.env.REACT_APP_ENVIRONMENT;
        fullUrl = process.env[envUrl];

        if (body) {
            fullUrl += `&${body}`;
        }

        // Prevent caching by adding a timestamp
        fullUrl += `&_=${new Date().getTime()}`;
        //const fullUrl = 'https://qua-pci.healthplan.com/v2/index.php?w1=PciTokenCTL/PciWebProcessCTL&no_html=true&process_type=TOKENIZE_WEB_DATA&response_type=json&callback=callback&en_nm=bLR4jnioG1aZeu8JAHyczkKyixrqfUoTKstqVRigQMdtTxMaeZZVXyMUigprHUqA6ArMecTBiWqKv8pwj9yVdwiWHPgLVUxa9A1Xc6X9dyZ67Kr5KuvJTGgFVze%2FNhPFzYjntHsVT5RnOugYh%2BjAzG0PUWHYoIF0wBr3EmOIidTyjYA02rbvOBfqcBLp05njK6dtusk%2Bks1SynDJqKuE9I2aHwpAzE4HPHvHZtdnu0ZlqzaCeVk8jFcrWmVHFwJCpi%2BHtTu%2FtAsADNXOxnkiHXIOqQ4iWWSImFRl1pCE4pnuvUXTfBITnapnUJYWQX77064o8jDBAEjxtlYCbaWFcw%3D%3D&en_ad=P0UgEwGzMe9mLH63y3KlNYEm9TVRD%2B4mVp3U8eKbWl0fc2R%2B4IBvtC8W9FqoUIrKrnrOil%2BIhorsU51AiddJAo0%2Bn032yUr6IEClF2w9N7IUUCSO5mI5aCk6F%2BsJDv2NcjdWV5P8suFGWZQeR4rJWQzzqg5ONJAxACN6AuMoVmAlAuudHzWuFF0qYwus9PbD8ptj3n8LZbVoVo%2Bx45d9kkvNnrBYLsF229JdjSGFIrndRtPxAyla2vgFjoTUU3nERobMMcE396TFVylbgun8Md5%2FGaTZ%2BOXaQWHQ52FnKDH7N8m4aBLqWg25pNqJkLca2Xx89F5BoDfCvYwkMZDbHQ%3D%3D&en_cn=t8JdYk0msZnDbyuzj5iy5mtN0HHnAxC74iClOykkzYDzU56%2FU8QOpXpydXwp4VSdOcFs5DcQpaogGDmPmTkuV%2FRAaiFnj01wDI0Sjjvaz6DfKTWIEtmbDdkj8w9Xiym%2BHAjT840kEMIznv%2FnDgj2rwA0E1poIF47OJmMlfy44vQ1JMkSq8cB9%2FeW8d9ZDd%2BLS1mHZw1LS45GAY3NgMpwZXi%2FcoZ9QSOY4%2BMj2Ck8Iq%2BxIL463%2BVQOQ89Y0xE6ognxbt668A0REkcNi%2Fpa7ySCzQqNPkjtdW4waTzZ%2FjK0p4Pufm3B8F6GKbqcNIWZ6xJVXzg4uYYnbQWbvjl5y%2BOag%3D%3D&en_pi=RgClAUo0DwgE4t05wMkbwWWw0Hn%2FJweympbjDdIlqIxr8%2BFzi5a6rpRRTBk1nkb5isTQhGVIlGq7RRqElBiJFnXt2zT%2Bq4nO0WOHAkhwVxHf1VNcjssUd0yQLbLy5wmSoiaZ5yVWpur9qZGRm0lR2bi2Y9VHGw%2FFZCtdQaMYNovOk53qRPFTf0lGZKYKlGi0MLHlS%2BlsrOu0k1NrHoVywMkCM0Ysb8IVYUI%2Bk7UDRbvOacb2uKg8s0gJxmoOqJ43thes%2BoUaa7BbB3tJWtkgOI8I1vSO%2FcvAIVH7%2FlkdjkL37TYan%2FLQgR%2Fj84s5mOZTH0mcqU6%2BwLG%2F0pBtg9NEDw%3D%3D&&1743666860321'
        getApiService(fullUrl, "", APIHeaders)
            .then((result) => {
                if (result) {
                    if (result.status && result.data && result.status === 200) {
                        response = result.data;
                        if (!response.error) {
                        } else {
                            //handleLoginErr(response?.Message);
                            console.log("Failed payment");
                        }
                    } else if (result.status === 404) {
                        console.log(result.status + " " + "Failed");
                    } else {
                        const errorTxt = "Failed" + result.status;
                        var resultErr = "";
                        if (result.error) {
                            resultErr = result.error;
                        }
                        if (result.errors && result.errors.text) {
                            resultErr += result.errors.text;
                        }
                        console.log(errorTxt + "Technical Error : " + resultErr);
                    }
                } else {
                    console.log("Technical Error");
                }
            })
            .catch((error) => {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    console.log("Technical Error");
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log("Technical Error");
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log("Technical Error");
                }
            })
            .finally(() => {
                // Code that runs regardless of success or failure
                if (
                    response?.reason &&
                    response.reason === "ACCEPT" &&
                    response?.token
                ) {
                    console.log("Account Created Successfully");
                    insertPymtToken(response, body_pre_encrypt);
                } else {
                    setLoading(false);
                    console.log(response);
                    console.log("Failed to create Account");
                    
                    if(response?.code == 102) {                        
                        handleCloseModal();
                        if(formSubmitType === 'EFT'){
                            sendDataToParent(genericContent?.billing_add_account_eft_routing_no_invalid_err, 'error');
                        }else if(formSubmitType === 'CCD'){
                            sendDataToParent(genericContent?.billing_add_account_cc_no_wrong_input_err, 'error');
                        }
                        
                    }else{
                        handleCloseModal();
                        sendDataToParent(genericContent?.billing_add_account_eft_routing_no_wrong_input_err, 'error');
                    }
                    //sendDataToParent(JSON.stringify(response.message), 500);
                }
            });	
    };
    const insertPymtToken = (tokenizationResp, params) => {
        let accountType = "";
        let sourceType = "";
        const accountLast4 = params?.cc_number
            ? params.cc_number.toString().slice(-4)
            : params?.check_number
                ? params.check_number.toString().slice(-4)
                : "";
        //console.log("params => "+ JSON.stringify(params, null, 2));
        //console.log((params.method === "CC"));
        if (params.method === "CC") {
            accountType = "CREDIT_CARD";
            sourceType = "CCD";
        } else {
            accountType = "EFT";
            sourceType = "EFT";
        };

        // const accountType = typeAccount;

        const accountUse = params?.check_level ? params.check_level : "PERSONAL";
        const bankAcctType = params?.check_type ? params.check_type : "CHECKING";
        //const cardCvvNo = params?.card_cvNumber ? params.card_cvNumber : "";
        let accountHoderAddr = { 'address1': params.street1, 'address2': params.street2, 'city': params.city, 'state': params.state, 'zip': params.zip, 'zipPlus4': '0000' };

        const ccExpiryDate =
            params?.cc_exp_month && params?.cc_exp_year
                ? getMonthEndDate(
                    parseInt(params.cc_exp_month, 10) - 1,
                    parseInt(params.cc_exp_year, 10)
                )
                : "";

        let dataPayload = new FormData();

        // Append your form fields to FormData
        dataPayload.append("accountType", accountType);
        dataPayload.append("cim", Payload?.cim);
        dataPayload.append("paymentTokenSeqNumber", 0);
        dataPayload.append("accountHolderName", params.first_name);
        dataPayload.append("logonId", "MEMBERPORTAL");
        dataPayload.append("initialPmt", "Y");
        dataPayload.append("cimSource", "C");
        dataPayload.append("tokenId", tokenizationResp.token);
        dataPayload.append("tokenOrigin", "WF");
        dataPayload.append("standardEntryClass", "WEB");
        dataPayload.append("acctCardlast4", accountLast4);
        //dataPayload.append("ccdType", params.cc_type);
        //dataPayload.append("ccdExpirationDate", ccExpiryDate);
        dataPayload.append("authorizationSource", "MEMBERPORTAL");
        dataPayload.append("authorizationEntity", "MEMBER-SSO-CASENUM");
        dataPayload.append("IpAddress", "10.24.71.78");
        dataPayload.append("originatorMessge", "none");
        dataPayload.append("accountHolderPhone", params.phone);
        dataPayload.append("accountUse", accountUse);
        dataPayload.append("accountHolderAddress", JSON.stringify(accountHoderAddr));
        dataPayload.append("avsConfirmationNum", tokenizationResp.avs_confirmation_number);
        dataPayload.append("avsTokenizationTimestamp", tokenizationResp.avs_timestamp);
        dataPayload.append("avsResponse", tokenizationResp.avs_response);
        dataPayload.append("requestEntryClass", params.authsource);

        if (params.method === "CC") {
            dataPayload.append("ccdType", params.cc_type);
            dataPayload.append("ccdExpirationDate", ccExpiryDate);
        }
        if (params.method === "EFT") {
            dataPayload.append("eftTransitNumber", params.check_routing);
            dataPayload.append("eftAccountType", bankAcctType);
        }
        if((paymentConfig !== null && paymentConfig.debit_card)?.debit_card_allowed === 'YES' && isChecked === 'true'){
        
            dataPayload.append("debitCardAllowed", "Y");
        }

        let todayDate = getTodayDate();

        const headers = {
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region": Payload?.region,
            "X-Hps-Site-Id": Payload?.site_id,
            "X-Hps-Carrier": Payload?.owning_carrier
        };

        if (dataPayload) {
            postData(
                process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_INSRT_PYMT_TOKEN_API_URL,
                "",
                dataPayload,
                headers
            )
                .then((response) => {
                    setLoading(false);
                    if (response) {
                        if (response?.data?.statusCode !== 200) {
                            handleCloseModal();
                            sendDataToParent(genericContent?.service_post_error, 'error');
                        } else {
                            handleCloseModal();
                            sendDataToParent(genericContent?.billing_add_account_success_msg, 'success');
                        }
                    } else {
                        handleCloseModal();
                        sendDataToParent(genericContent?.service_post_error, 'error');

                    }
                })
                .catch((error) => {
                    setLoading(false);
                    handleCloseModal();
                    sendDataToParent(genericContent?.service_post_error, 'error');
                });
        } else {
            sendDataToParent(genericContent?.service_post_error, 'error');
        }
    };
    const getMonthEndDate = (month, year) => {
        // Month is 0-based, so January is 0, February is 1, and so on.
        // Create a new Date object for the first day of the next month.
        const fullYear = year < 100 ? 2000 + year : year; // If year is < 100, prepend '20'
        const date = new Date(fullYear, month + 1, 0);
        const yearFormatted = date.getFullYear();
        const monthFormatted = (date.getMonth() + 1).toString().padStart(2, "0"); // Adds leading zero
        const dayFormatted = date.getDate().toString().padStart(2, "0"); // Adds leading zero

        return `${yearFormatted}-${monthFormatted}-${dayFormatted}`;
    };
    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = (today.getMonth() + 1).toString().padStart(2, "0"); // Adds leading zero
        const day = today.getDate().toString().padStart(2, "0"); // Adds leading zero

        return `${year}-${month}-${day}`;
    };

    const getCardType = (type) => {
        let card_type = '';
        switch (type.trim()) {
            case 'MC':
                card_type = 'MasterCard';
                break;
            case 'mastercard':
                card_type = 'MasterCard';
                break;
            case 'VISA':
                card_type = 'Visa';
                break;
            case 'visa':
                card_type = 'Visa';
                break;
            case 'DISC':
                card_type = 'Discover Card';
                break;
            case 'AMEX':
                card_type = 'American Express';
                break;
        }
        return card_type;
    };
    
    const hasFocusedRef = useRef(false);
    useEffect(() => {
        if (apiCallsCompleted && ref.current && !hasFocusedRef.current) {
            const activeEl = document.activeElement;
            const isEditingField =
                activeEl &&
                (activeEl.tagName === 'INPUT' ||
                 activeEl.tagName === 'TEXTAREA' ||
                 activeEl.tagName === 'SELECT' ||
                 activeEl.isContentEditable);

            if (!isEditingField) {
                requestAnimationFrame(() => {
                    if (ref.current) {
                        ref.current.focus({ preventScroll: true });
                        hasFocusedRef.current = true;
                    }
                });
            }
        }
    }, [apiCallsCompleted]);
    
    return (
        <>  
            <main
            role="main"
            tabIndex="-1"
            ref={ref}
            aria-label="Add Account Main Content"
            style={{ outline: 'none' }}
            >     
            
            <Modal.Header className={`modal-header ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
                {/* Mobile Dropdown for Q5 Carrier */}
                {Payload?.owning_carrier === 'Q5' && (
                    <div className="d-block d-md-none w-100 pb-3" style={{ paddingRight: '40px' }}>
                        <label
                            htmlFor="add-account-tab-select"
                            className="q5-payment-type-label"
                            id="add-account-tab-select-label"
                        >
                            Account Type
                        </label>
                        <Form.Select
                            id="add-account-tab-select"
                            value={accountKey}
                            onChange={(e) => setAccountKey(e.target.value)}
                            aria-label="Select account type to add"
                            aria-labelledby="add-account-tab-select-label"
                            className="payment-type-select"
                            tabIndex={0}
                        >
                            <option value="cc">
                                {(Payload?.owning_carrier === 'Q5') ? overViewContent.billing_add_account_add_debit_account_title : overViewContent.billing_add_account_add_cc_account_title}
                            </option>
                            <option value="eft">
                                {overViewContent.billing_add_account_add_eft_account_title}
                            </option>
                        </Form.Select>
                    </div>
                )}

                {/* Tab Navigation (Hidden on mobile for Q5, Always shown for other carriers) */}
                <div className={`nav nav-tabs ${Payload?.owning_carrier === 'Q5' ? 'd-none d-md-flex' : ''}`} id="nav-tab" role="tablist">
                    <button className={`nav-link me-xl-3 ${accountKey === 'cc' ? 'active' : ''}`} id="nav-CC-tab" 
                    data-bs-toggle="tab" 
                    data-bs-target="#nav-CC" 
                    type="button"
                    role="tab" 
                    aria-controls="nav-CC-tab" 
                    aria-selected={accountKey === 'cc' ? 'true' : 'false'}
                    onClick={() => setAccountKey('cc')}
                    tabIndex="0"
                    >
                        <span class="me-2">
                            {(Payload?.owning_carrier === 'Q5') ? overViewContent.billing_add_account_add_debit_account_title : overViewContent.billing_add_account_add_cc_account_title}
                        </span>
                    </button>

                    <button className={`nav-link me-xl-3 ${accountKey === 'eft' ? 'active' : ''}`} id="nav-EFT-tab"
                    data-bs-toggle="tab" 
                    data-bs-target="#nav-EFT" 
                    type="button"
                    role="tab" 
                    aria-controls="nav-EFT"
                    aria-selected={accountKey === 'eft' ? 'true' : 'false'}
                    onClick={() => setAccountKey('eft')}
                    tabIndex="0"
                    >
                        <span class="me-2">
                            {overViewContent.billing_add_account_add_eft_account_title}
                        </span>
                    </button>
                </div>
            </Modal.Header>
            <Modal.Body>
            {isLoading && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
                    <Spinner animation="border" role="status" ></Spinner>
                    <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                </div>
            )}
            {!isLoading && accountKey === 'cc' && <Box role="tabpanel" aria-label="Credit or Debit Card Account Form">
                <Form tabIndex={0}>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="ccnumber">
                                <Form.Label aria-label="CardNumber">{overViewContent.billing_add_account_cc_no_text}<span class="text-danger"> *</span>
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={renderTooltip}
                                        delay={{ show: 100, hide: 200 }}
                                    >
                                        <i
                                            className="fe fe-info"
                                            style={{cursor: 'pointer' }}
                                        ></i>
                                    </OverlayTrigger>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    placeholder=""
                                    className="credit_card_number"
                                    value={ccFormValues.ccnumber}
                                    name="ccnumber"
                                    autoComplete="new-password"
                                    onChange={(e) => {
                                        const value = e.target.value
                                        if (/^\d*$/.test(value)) {
                                            handleChange(e)
                                        }
                                    }}
                                    isInvalid={!!ccFormErrors.ccnumber}
                                    onPaste={(e) => {
                                        e.preventDefault();
                                        return false;
                                    }}
                                    onCopy={(e) => {
                                        e.preventDefault();
                                        return false;
                                    }}
                                    aria-label="Credit-card-Number"
                                />
                                <Form.Control.Feedback type="invalid">{ccFormErrors.ccnumber}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="reenterccnumber">
                                <Form.Label className="reenter_card_number" aria-label="Re-enterCardNumber" >{overViewContent.billing_add_account_re_enter_cc_no_text}<span class="text-danger"> *</span>
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={renderTooltip}
                                        delay={{ show: 100, hide: 200 }}
                                    >
                                        <i
                                            className="fe fe-info"
                                            style={{cursor: 'pointer' }}
                                        ></i>
                                    </OverlayTrigger>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    placeholder=""
                                    className="credit_card_number"
                                    name="reenterccnumber"
                                    autoComplete="new-password"
                                    value={ccFormValues?.reenterccnumber}
                                    isInvalid={!!ccFormErrors?.reenterccnumber}
                                    onChange={(e) => {
                                        const value = e.target.value
                                        if (/^\d*$/.test(value)) {
                                            handleChange(e)
                                        }
                                    }}
                                    onPaste={(e) => {
                                        e.preventDefault();
                                        return false;
                                    }}
                                    onCopy={(e) => {
                                        e.preventDefault();
                                        return false;
                                    }}
                                    aria-label="Re-enter-Credit-card-Number"

                                />
                                <Form.Control.Feedback type="invalid">{ccFormErrors.reenterccnumber}</Form.Control.Feedback>
                            </Form.Group>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group controlId="cardtype">
                                        <Form.Label aria-label="CardType" className="billing_type" >{overViewContent.billing_add_account_type_text}<span class="text-danger"> *</span></Form.Label>
                                        {debitCardAllowed === 'true' && paymentConfig !== null ? (
                                        <Form.Select
                                            aria-label="Card Type"
                                            defaultValue="Select Card Type"
                                            name="cardtype"
                                            className="credit_card_number select-font-size"
                                            value={ccFormValues?.cardtype}
                                            isInvalid={!!ccFormErrors?.type}
                                            onChange={handleChange}
                                            style={{width: Payload?.owning_carrier === 'Q5' ? '100%' : ''}}
                                        >
                                            <option>{overViewContent.billing_add_account_select_card_type_dropdown}</option>
                                            {paymentConfig !== null && paymentConfig.debit_card?.debit_card_types.split(',').map((type, index) => (
                                                <option value={type.trim()}>{getCardType(type)}</option>

                                            ))};
                                            
                                        </Form.Select>
                                        ) : (
                                            paymentConfig !== null ? (
                                            <Form.Select
                                                aria-label="Card Type"
                                                defaultValue="Select Card Type"
                                                name="cardtype"
                                                className="credit_card_number select-font-size"
                                                value={ccFormValues?.cardtype}
                                                isInvalid={!!ccFormErrors?.type}
                                                onChange={handleChange}
                                                style={{width: Payload?.owning_carrier === 'Q5' ? '100%' : ''}}
                                            >
                                                <option>{overViewContent.billing_add_account_select_card_type_dropdown}</option>
                                                {paymentConfig.credit_card?.credit_card_types.split(',').map((type, index) => (
                                                    <option value={type.trim()}>{getCardType(type)}</option>

                                                ))};
                                                </Form.Select>
                                            ) : (
                                            <Form.Select
                                                aria-label="Card Type"
                                                defaultValue="Select Card Type"
                                                name="cardtype"
                                                className="credit_card_number select-font-size"
                                                value={ccFormValues?.cardtype}
                                                isInvalid={!!ccFormErrors?.type}
                                                onChange={handleChange}
                                                style={{width: Payload?.owning_carrier === 'Q5' ? '100%' : ''}}
                                            >
                                                <option>{overViewContent.billing_add_account_select_card_type_dropdown}</option>
                                                <option value="VISA">{getCardType('VISA')}</option>
                                                <option value="MC">{getCardType('MC')}</option>
                                                {Payload?.owning_carrier !== 'J1' && (
                                                <option value="DISC">{getCardType('DISC')}</option>
                                                )}
                                            </Form.Select>
                                            )

                                        )}
                                        <Form.Control.Feedback type="invalid">{ccFormErrors?.type}</Form.Control.Feedback>
                                    </Form.Group>
                                    </Col>
                            
                            </Row>
                            <Form.Group className="mb-3" controlId="cardname">
                                <Form.Label aria-label="CardHolder" className="card_holder_name">
                                    {overViewContent.billing_add_account_card_holder_name_text}
                                    <span className="text-danger">*</span>
                                </Form.Label>

                                <div style={{ position: "relative" }}>
                                    <Form.Control
                                        aria-label="CardHolderName"
                                        type="text"
                                        placeholder=""
                                        className="credit_card_number"
                                        name="cardname"
                                        value={cardname}
                                        isInvalid={!!ccFormErrors?.cardname}
                                        onChange={handleNameChange}
                                    />
                                    <img
                                        src={cardholder}
                                        alt="cardholder"
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            right: "10px",
                                            transform: "translateY(-50%)",
                                            width: "20px",
                                            height: "20px",
                                            pointerEvents: "none"
                                        }}
                                    />
                                    <Form.Control.Feedback type="invalid">{ccFormErrors?.cardname}</Form.Control.Feedback>
                                </div>
                            </Form.Group>

                            <Row>
                                <Col md={8} xs={12}>
                                    <Form.Group className="mb-3" controlId="expirydate">
                                        <Form.Label className="expiry_date" 
                                        aria-label="ExpiredDate">{overViewContent.billing_add_account_expiry_date_text}<span class="text-danger">*</span></Form.Label>
                                        <Row>
                                            {/* Month Field */}
                                            <Col md={6} xs={12}>
                                                <Form.Select
                                                    aria-label="Expiry-Month"
                                                    value={ccFormValues?.expiryMonth}
                                                    className="credit_card_number select-font-size"
                                                    isInvalid={!!ccFormErrors?.expiryMonth}
                                                    onChange={handleMonthChange}
                                                >
                                                    <option className="expirydate">{overViewContent?.billing_add_account_select_month_text}</option>
                                                    {expiryMonth.map((month, index) => (
                                                        <option key={index} value={index}>
                                                            {month}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">{ccFormErrors?.expiryMonth}</Form.Control.Feedback>
                                            </Col>

                                            {/* Year Field */}
                                            <Col md={6} xs={12}>
                                                <Form.Group controlId="expiryYearSelect">
                                                    <Form.Select
                                                        aria-label="Expiry-Year"
                                                        value={ccFormValues?.expiryYear || ""}
                                                        className="credit_card_number select-font-size"
                                                        isInvalid={!!ccFormErrors?.expiryYear}
                                                        onChange={handleYearChange}
                                                    >
                                                        <option value="" className="expirydate">{overViewContent?.billing_add_account_select_year_text}</option>
                                                        {expiryYear.map((year, index) => (
                                                            <option key={index} value={year}>
                                                                {year}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        {ccFormErrors?.expiryYear || "Please select a year."}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>

                                {/* CVV Field */}
                                <Col md={4} xs={12}>
                                    <Form.Group className="mb-3" controlId="cvv">
                                        <Form.Label className="cvv_text" aria-label="CVV">{overViewContent.billing_add_account_cvv_text}<span class="text-danger">*</span>
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={renderTooltip1}
                                                delay={{ show: 100, hide: 200 }}
                                            >
                                                <i
                                                    className="fe fe-info"
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            </OverlayTrigger>
                                        </Form.Label>
                                        <Form.Control
                                            aria-label="CVV"
                                            type="password"
                                            placeholder=""
                                            className="credit_card_number"
                                            name="cvv"
                                            autoComplete="new-password"
                                            value={ccFormValues?.cvv}
                                            isInvalid={!!ccFormErrors?.cvv}
                                            onChange={handleChange}
                                        />
                                        <Form.Control.Feedback type="invalid">{ccFormErrors?.cvv}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>


                        </Col>
                        <Col>
                            <Row className="" style={{ display: 'flex' }}>
                                <Col>
                                    <Form.Group className="mb-3" controlId="paymentaccount">
                                        <Form.Label className="account_use" aria-label="Account">{overViewContent.billing_add_account_account_use_text}</Form.Label>
                                        <Form.Select
                                            aria-label="Payment Account"
                                            defaultValue="Select Payment Account"
                                            name="paymentaccount"
                                            className="credit_card_number select-font-size"
                                            onChange={handleChange}
                                            value={paymentaccount}
                                            isInvalid={!!ccFormErrors?.paymentaccount}

                                        >
                                                    <option value="PERSONAL">{overViewContent.billing_add_account_select_account_use_personal_dropdown}</option>
                                            <option value="BUSINESS">{overViewContent.billing_add_account_select_account_use_business_dropdown}</option>
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">{ccFormErrors?.paymentaccount}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="authsource">
                                        <Form.Label className="auth_type" aria-label="AuthType">{overViewContent.billing_add_account_authorization_type_text}</Form.Label>
                                        <Form.Select
                                            aria-label="Authorization Type"
                                            name="authsource"
                                            value={ccFormValues?.authsource}
                                            onChange={handleChange}
                                            className="credit_card_number select-font-size"
                                        >
                                            <option className="eftcard" value="TEL">{overViewContent.billing_add_account_authorization_type_agent_dropdown}</option>
                                            <option className="eftcard" value="PPD">{overViewContent.billing_add_account_authorization_type_paper_dropdown}</option>
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">{ccFormErrors?.authsource}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Form.Group className="mb-3" controlId="billingaddress1">
                                <Form.Label className="biling_address1" aria-label="BillingAddress1" >{overViewContent.billing_add_account_billing_address1_text}<span class="text-danger">*</span></Form.Label>
                                <Form.Control
                                    aria-label="BillingAddress1"
                                    type="text"
                                    placeholder=""
                                    className="credit_card_number"
                                    name="billingaddress1"
                                    value={billingaddress1}
                                    maxLength={55}
                                    isInvalid={!!ccFormErrors?.billingaddress1}
                                    onChange={handleAddressChange}
                                />
                                <Form.Control.Feedback type="invalid">{ccFormErrors?.billingaddress1}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="billingaddress2">
                                <Form.Label className="billing_address2" aria-label="BillingAddress2">{overViewContent.billing_add_account_billing_address2_text}</Form.Label>
                                <Form.Control
                                    aria-label="BillingAddress2"
                                    type="text"
                                    placeholder=""
                                    value={billingaddress2}
                                    className="credit_card_number"
                                    name="billingaddress2"
                                    maxLength={55}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Row className="mb-3" style={{ display: 'flex', alignItems: 'end' }}>
                                <Col>
                                    <Form.Group controlId="state">
                                        <Form.Label className="state" aria-label="State">{overViewContent.billing_add_account_state_text}<span class="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            aria-label="State"
                                            defaultValue="Select State"
                                            name="state"
                                            //value={ccFormValues?.state}
                                            value={state}
                                            isInvalid={!!ccFormErrors?.state}
                                            onChange={(e) =>
                                                handleStateChange(
                                                    states.find((s) => s.isoCode === e.target.value),
                                                )
                                            }
                                            className="credit_card_number select-font-size"
                                        >
                                            {states.map((state) => (
                                                <option key={state.isoCode} value={state.isoCode} >
                                                    {state.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">{ccFormErrors?.state}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="city">
                                        <Form.Label className="city" aria-label="City" >{overViewContent.billing_add_account_city_text}<span class="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            aria-label="Select City"
                                            type="text"
                                            placeholder=""
                                            className="credit_card_number"
                                            name="city"
                                            value={city}
                                            isInvalid={!!ccFormErrors?.city}
                                            onChange={handleCityChange}
                                        />
                                        <Form.Control.Feedback type="invalid">{ccFormErrors?.city}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3" style={{ display: 'flex', alignItems: 'end' }}>
                                <Col>
                                    <Form.Group className="mb-3" controlId="zip">
                                        <Form.Label className="zip" aria-label="Zip" >{overViewContent.billing_add_account_zip_text}<span class="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            aria-label="Zip"
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            placeholder=""
                                            className="credit_card_number"
                                            name="zip"
                                            value={zip}
                                            isInvalid={!!ccFormErrors?.zip}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                if (/^\d*$/.test(value)) {
                                                    handleZipCodeChange(e)
                                                }
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">{ccFormErrors?.zip}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="phonenumber">
                                        <Form.Label className="phone_number" aria-label="Phonenumber" >{overViewContent.billing_add_account_phone_no_text}<span class="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            aria-label="Phone Number"
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            placeholder=""
                                            className="credit_card_number"
                                            name="phonenumber"
                                            value={phonenumber}
                                            isInvalid={!!ccFormErrors?.phonenumber}
                                            onChange={(e) => {
                                                const value = e.target.value
                                                if (/^\d*$/.test(value)) {
                                                    handlePhoneNumberChange(e)
                                                }
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">{ccFormErrors?.phonenumber}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="button-row">
                                <Col>
                                    {/* Responsive button order for Q5 carrier */}
                                    {Payload?.owning_carrier === 'Q5' ? (
                                        <>
                                            {/* Mobile/Tablet: Add Card top, Cancel bottom */}
                                            <div className="q5-mobile-btns d-block d-lg-none">
                                                <Button
                                                    aria-label="AddCard"
                                                    className="add-card-button btn btn-secondary btn-lg mt-4"
                                                    type="submit"
                                                    onClick={handleSubmit}
                                                >
                                                    {overViewContent.billing_add_account_add_card_btn}
                                                </Button>
                                                
                                                <Button
                                                    aria-label="Cancel"
                                                    variant="outline-primary"
                                                    type="button"
                                                    className="cancel-button btn btn-outline-secondary btn-lg"
                                                    onClick={() => handleCloseModal()}
                                                >
                                                    {overViewContent.billing_add_account_cancel_btn}
                                                </Button>
                                            </div>
                                            {/* Large screens: Cancel first, Add Card second */}
                                            <div className="q5-desktop-btns d-none d-lg-block">
                                                <Button
                                                    aria-label="Cancel"
                                                    variant="outline-primary"
                                                    type="button"
                                                    className="cancel-button btn btn-outline-secondary btn-lg"
                                                    onClick={() => handleCloseModal()}
                                                >
                                                    {overViewContent.billing_add_account_cancel_btn}
                                                </Button>
                                                <Button
                                                    aria-label="AddCard"
                                                    className="add-card-button btn btn-secondary btn-lg mt-4"
                                                    type="submit"
                                                    onClick={handleSubmit}
                                                >
                                                    {overViewContent.billing_add_account_add_card_btn}
                                                </Button>
                                            </div>
                                        </>
                                    ) : (
                                        // Default for non-Q5 carriers
                                        <>
                                            <Button
                                                aria-label="Cancel"
                                                variant="outline-primary"
                                                type="button"
                                                className="cancel-button btn btn-outline-secondary btn-lg"
                                                onClick={() => handleCloseModal()}
                                            >
                                                {overViewContent.billing_add_account_cancel_btn}
                                            </Button>
                                            <Button
                                                aria-label="AddCard"
                                                className="add-card-button btn btn-secondary btn-lg mt-4"
                                                type="submit"
                                                onClick={handleSubmit}
                                            >
                                                {overViewContent.billing_add_account_add_card_btn}
                                            </Button>
                                        </>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </Box >
            }
            {
                !isLoading && accountKey === 'eft' && <Box role="tabpanel" aria-label="Electronic Funds Transfer Account Form">
                    <Form tabIndex={0}>
                        <Row>
                            <Col>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="routingnumber">
                                            <Form.Label aria-label="RoutingNumber">{overViewContent.billing_add_account_eft_routing_no_text}<span class="text-danger">*</span>
                                                <OverlayTrigger
                                                    placement="bottom"
                                                    overlay={ABAroutingTooltip}
                                                    delay={{ show: 100, hide: 200 }}
                                                >
                                                    <i
                                                        className="fe fe-info"
                                                        style={{ marginLeft: '5px', cursor: 'pointer' }}
                                                    ></i>
                                                </OverlayTrigger>
                                            </Form.Label>
                                            <Form.Control
                                                aria-label="Routing-Number"
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                placeholder=""
                                                className="credit_card_number"
                                                name="routingnumber"
                                                autoComplete="new-password"
                                                value={eftFormValues?.routingnumber}
                                                isInvalid={!!eftFormErrors?.routingnumber}
                                                onPaste={(e) => {
                                                    e.preventDefault();
                                                    return false;
                                                }}
                                                onCopy={(e) => {
                                                    e.preventDefault();
                                                    return false;
                                                }}
                                                onChange={efthandleChange}
                                            />
                                            <Form.Control.Feedback type="invalid">{eftFormErrors?.routingnumber}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="reenterroutingnumber">
                                            <Form.Label arai-label="Ree">{overViewContent.billing_add_account_eft_re_enter_routing_no_text}<span class="text-danger">*</span> </Form.Label>
                                            <Form.Control
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                placeholder=""
                                                className="credit_card_number"
                                                name="reenterroutingnumber"
                                                autoComplete="new-password"
                                                value={eftFormValues?.reenterroutingnumber}
                                                isInvalid={!!eftFormErrors?.reenterroutingnumber}
                                                onPaste={(e) => {
                                                    e.preventDefault();
                                                    return false;
                                                }}
                                                onCopy={(e) => {
                                                    e.preventDefault();
                                                    return false;
                                                }}
                                                onChange={efthandleChange}
                                            />
                                            <Form.Control.Feedback type="invalid">{eftFormErrors?.reenterroutingnumber}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Form.Group className="mb-3" controlId="accountnumber">
                                    <Form.Label aria-label="Account-Number">{overViewContent.billing_add_account_eft_account_no_text}<span class="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        aria-label="Account-Number"
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        placeholder=""
                                        className="credit_card_number"
                                        name="accountnumber"
                                        autoComplete="new-password"
                                        value={eftFormValues?.accountnumber}
                                        isInvalid={!!eftFormErrors?.accountnumber}
                                        onPaste={(e) => {
                                            e.preventDefault();
                                            return false;
                                        }}
                                        onCopy={(e) => {
                                            e.preventDefault();
                                            return false;
                                        }}
                                        onChange={efthandleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">{eftFormErrors?.accountnumber}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="reenteraccountnumber">
                                    <Form.Label aria-label="Renter-Account-Number">{overViewContent.billing_add_account_eft_re_enter_account_no_text}<span class="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        aria-label="Reenter-Account-Number"
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        placeholder=""
                                        className="credit_card_number"
                                        name="reenteraccountnumber"
                                        autoComplete="new-password"
                                        value={eftFormValues?.reenteraccountnumber}
                                        isInvalid={!!eftFormErrors?.reenteraccountnumber}
                                        onPaste={(e) => {
                                            e.preventDefault();
                                            return false;
                                        }}
                                        onCopy={(e) => {
                                            e.preventDefault();
                                            return false;
                                        }}
                                        onChange={efthandleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">{eftFormErrors?.reenteraccountnumber}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="accountname">
                                    <Form.Label aria-label="AccountName">{overViewContent.billing_add_account_eft_account_name_text}<span class="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        aria-label="Account-Name"
                                        type="text"
                                        placeholder=""
                                        className="credit_card_number"
                                        name="accountname"
                                        value={accountname}
                                        isInvalid={!!eftFormErrors?.accountname}
                                        onChange={EFThandleNameChange}
                                    />
                                    <Form.Control.Feedback type="invalid">{eftFormErrors?.accountname}</Form.Control.Feedback>
                                </Form.Group>
                                <Row>
                                    <Col>
                                        <Form.Group controlId="accounttype">
                                            <Form.Label aria-label="AccountType">{overViewContent.billing_add_account_eft_account_type_text}<span class="text-danger">*</span></Form.Label>
                                            <Form.Select
                                                aria-label="Account Type"
                                                defaultValue="Select Account Type"
                                                name="accounttype"
                                                value={accounttype}
                                                isInvalid={!!eftFormErrors?.accounttype}
                                                onChange={efthandleChange}
                                                className="credit_card_number select-font-size"
                                            >
                                                <option className="eftcard" value="CHECKING">{overViewContent.billing_add_account_eft_select_checking_account_dropdown}</option>
                                                <option className="eftcard" value="SAVING">{overViewContent.billing_add_account_eft_select_savings_account_dropdown}</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">{eftFormErrors?.accounttype}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group controlId="accountuse">
                                            <Form.Label aria-label="Account Use">{overViewContent.billing_add_account_eft_account_use_text}<span class="text-danger">*</span></Form.Label>
                                            <Form.Select
                                                aria-label="Account Use"
                                                defaultValue="Select Account Use"
                                                name="accountuse"
                                                value={accountuse}
                                                isInvalid={!!eftFormErrors?.accountuse}
                                                onChange={efthandleChange}
                                                className="credit_card_number select-font-size"
                                            >
                                                <option className="eftcard" value="PERSONAL">{overViewContent.billing_add_account_eft_select_personal_dropdown}</option>
                                                <option className="eftcard" value="BUSINESS">{overViewContent.billing_add_account_eft_select_business_dropdown}</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">{eftFormErrors?.accountuse}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="billingaddress1">
                                    <Form.Label aria-label="Address1">{overViewContent.billing_add_account_billing_address1_text}<span class="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        aria-label="Billing Address1"
                                        type="text"
                                        placeholder=""
                                        className="credit_card_number"
                                        name="billingaddress1"
                                        value={eftbillingaddress1}
                                        isInvalid={!!eftFormErrors?.billingaddress1}
                                        maxLength={55}
                                        onChange={EFThandleAddressChange}
                                    />
                                    <Form.Control.Feedback type="invalid">{eftFormErrors?.billingaddress1}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="billingaddress2">
                                    <Form.Label aria-label="Address2">{overViewContent.billing_add_account_billing_address2_text}</Form.Label>
                                    <Form.Control
                                        aria-label="Billing Address2"
                                        type="text"
                                        placeholder=""
                                        className="credit_card_number"
                                        name="billingaddress2"
                                        value={eftbillingaddress2}
                                        maxLength={55}
                                        onChange={EFThandleAddress2Change}
                                    />
                                </Form.Group>
                                <Row className="mb-3" style={{ display: 'flex', alignItems: 'end' }}>
                                    <Col>
                                        <Form.Group controlId="state">
                                            <Form.Label aria-label="State">{overViewContent.billing_add_account_state_text}<span class="text-danger">*</span></Form.Label>
                                            <Form.Select
                                                aria-label="Select State"
                                                defaultValue="Select State"
                                                name="state"
                                                value={eftstate}
                                                isInvalid={!!eftFormErrors?.state}
                                                onChange={(e) =>
                                                    handleEFTStateChange(
                                                        states.find((s) => s.isoCode === e.target.value),
                                                    )
                                                }
                                                className="credit_card_number select-font-size"
                                            >
                                                {states.map((state) => (
                                                    <option key={state.isoCode} value={state.isoCode}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">{eftFormErrors?.state}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group controlId="city">
                                            <Form.Label aria-label="City">{overViewContent.billing_add_account_city_text}<span class="text-danger">*</span></Form.Label>
                                            <Form.Control
                                            aria-label="Select City"
                                            type="text"
                                            placeholder=""
                                            className="credit_card_number"
                                            name="eftcity"
                                            value={eftcity}
                                            isInvalid={!!eftFormErrors?.eftcity}
                                            onChange={handleEFTCityChange}
                                        />
                                            <Form.Control.Feedback type="invalid">{eftFormErrors?.eftcity}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row style={{ display: 'flex', alignItems: 'end' }}>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="zip">
                                            <Form.Label aria-lable="Zip">{overViewContent.billing_add_account_zip_text}<span class="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                aria-label="Zip"
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                placeholder=""
                                                className="credit_card_number"
                                                name="zip"
                                                value={eftzip}
                                                isInvalid={!!eftFormErrors?.zip}
                                                onChange={EFThandleZipCodeChange}

                                            />
                                            <Form.Control.Feedback type="invalid">{eftFormErrors?.zip}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="phonenumber">
                                            <Form.Label aria-label="Phone">{overViewContent.billing_add_account_phone_no_text}<span class="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                aria-label="Phone Number"
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                                placeholder=""
                                                className="credit_card_number"
                                                name="phonenumber"
                                                value={eftphonenumber}
                                                isInvalid={!!eftFormErrors?.phonenumber}
                                                onChange={EFThandlePhoneNumberChange}
                                            />
                                            <Form.Control.Feedback type="invalid">{eftFormErrors?.phonenumber}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group controlId="authsource">
                                            <Form.Label className="auth_type" aria-label="Authorization Type" >{overViewContent.billing_add_account_authorization_type_text}</Form.Label>
                                            <Form.Select
                                                aria-label="Select Authorization Type"
                                                name="authsource"
                                                value={eftFormValues?.authsource}
                                                onChange={efthandleChange}
                                                className="credit_card_number select-font-size"
                                            >
                                                <option className="eftcard" value="TEL">{overViewContent.billing_add_account_authorization_type_agent_dropdown}</option>
                                                <option className="eftcard" value="PPD">{overViewContent.billing_add_account_authorization_type_paper_dropdown}</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">{eftFormErrors?.accountuse}</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mb-3 button-row">
                                    <Col>
                                        {/* Responsive button order for Q5 carrier (EFT) */}
                                        {Payload?.owning_carrier === 'Q5' ? (
                                            <>
                                                {/* Mobile/Tablet: Add Bank Account top, Cancel bottom */}
                                                <div className="q5-eft-mobile-btns d-block d-lg-none">
                                                    <Button
                                                        aria-label="Submit"
                                                        type="submit"
                                                        className="add-card-button btn btn-secondary btn-lg mt-4"
                                                        onClick={efthandleSubmit}
                                                        style={{ fontSize: '14px' }}
                                                    >
                                                        {overViewContent.billing_add_account_eft_add_eft_account_btn}
                                                    </Button>
                                                    
                                                    <Button
                                                        aria-label="Cancel"
                                                        variant="outline-primary"
                                                        type="button"
                                                        className="cancel-button btn btn-outline-secondary btn-lg mt-4"
                                                        onClick={() => handleCloseModal()}
                                                        style={{ fontSize: '14px' }}
                                                    >
                                                        {overViewContent.billing_add_account_cancel_btn}
                                                    </Button>
                                                </div>
                                                {/* Large screens: Cancel first, Add Bank Account second */}
                                                <div className="q5-eft-desktop-btns d-none d-lg-block">
                                                    <Button
                                                        aria-label="Cancel"
                                                        variant="outline-primary"
                                                        type="button"
                                                        className="cancel-button btn btn-outline-secondary btn-lg mt-4"
                                                        onClick={() => handleCloseModal()}
                                                        style={{ fontSize: '14px' }}
                                                    >
                                                        {overViewContent.billing_add_account_cancel_btn}
                                                    </Button>
                                                    <Button
                                                        aria-label="Submit"
                                                        type="submit"
                                                        className="add-card-button btn btn-secondary btn-lg mt-4"
                                                        onClick={efthandleSubmit}
                                                        style={{ fontSize: '14px' }}
                                                    >
                                                        {overViewContent.billing_add_account_eft_add_eft_account_btn}
                                                    </Button>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Button
                                                    aria-label="Cancel"
                                                    variant="outline-primary"
                                                    type="button"
                                                    className="cancel-button btn btn-outline-secondary btn-lg mt-4"
                                                    onClick={() => handleCloseModal()}
                                                    style={{ fontSize: '14px' }}
                                                >
                                                    {overViewContent.billing_add_account_cancel_btn}
                                                </Button>
                                                <Button
                                                    aria-label="Submit"
                                                    type="submit"
                                                    className="add-card-button btn btn-secondary btn-lg mt-4"
                                                    onClick={efthandleSubmit}
                                                    style={{ fontSize: '14px' }}
                                                >
                                                    {overViewContent.billing_add_account_eft_add_eft_account_btn}
                                                </Button>
                                            </>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Box>
            }
           </Modal.Body>
        </main>
    </>
    )
}
export default Forms;